import React, { useState } from 'react';
import {
  Alert,
  Button, Form, Modal,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import validator from 'validator';

import { addRater } from '../../../../bridge';
import { __ } from '../../../../helpers/translations';

function AddRaterModal({
  respondentId, onCancel, onChanged,
}) {
  const [participantInput, setParticipantInput] = useState({
    firstName: '', lastName: '', email: '',
  });
  const [error, setError] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  const onChangeInput = (e, inputType) => {
    setParticipantInput({
      ...participantInput,
      [inputType]: e.target.value,
    });
  };

  const onClickCancel = () => {
    setParticipantInput({ firstName: '', lastName: '', email: '' });
    onCancel();
  };

  const onClickAdd = async () => {
    setError(false);
    const entry = {
      firstName: participantInput.firstName.trim(),
      lastName: participantInput.lastName.trim(),
      email: participantInput.email.trim().toLowerCase(),
    };

    if (!entry.firstName || !entry.lastName) {
      setError(__('G120'));
      return;
    }

    if (!validator.isEmail(entry.email)) {
      setError(__('G121'));
      return;
    }

    setIsSaving(true);
    const response = await addRater(respondentId, entry.firstName, entry.lastName, entry.email);
    setIsSaving(false);
    if (response.error) {
      setError(response.error);
      return;
    }

    onChanged();
    setParticipantInput({
      firstName: '', lastName: '', email: '',
    });
  };

  return (
    <Modal show centered onHide={onCancel}>
      <Modal.Header>
        <Modal.Title>{__('G338')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-2">
          <Form.Label className="mb-0">
            {__('G59')}
          </Form.Label>
          <Form.Control
            type="text"
            autoFocus
            disabled={isSaving}
            value={participantInput.firstName}
            onChange={(e) => onChangeInput(e, 'firstName')}
            placeholder={__('G60')}
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-0">
            {__('G61')}
          </Form.Label>
          <Form.Control
            type="text"
            disabled={isSaving}
            value={participantInput.lastName}
            onChange={(e) => onChangeInput(e, 'lastName')}
            placeholder={__('G62')}
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-0">
            {__('G116')}
          </Form.Label>
          <Form.Control
            type="email"
            disabled={isSaving}
            value={participantInput.email}
            onChange={(e) => onChangeInput(e, 'email')}
            placeholder={__('G117')}
          />
        </Form.Group>
        {error && (<Alert variant="danger">{error}</Alert>)}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClickCancel} disabled={isSaving}>
          {__('G106')}
        </Button>
        <Button variant="primary" disabled={isSaving} onClick={onClickAdd}>
          {__('G107')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

AddRaterModal.propTypes = {
  respondentId: PropTypes.string,
  onCancel: PropTypes.func,
  onChanged: PropTypes.func,
};

export default AddRaterModal;
